import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
class SubscriberAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'TaskGo';
  controllerName = 'Subscribers';

  getSubscriberInfo(taxOrBudgetCode) {
    let request = {
      url: this.getAPIUrl() + `/info?taxOrBudgetCode=${taxOrBudgetCode}`
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy thông tin hết hạn của license
   * @returns
   */
  getLicenseExpirationInfo(payload) {
    const me = this;
    let request = {
      url: `${this.getAPIUrl()}/expiration-info`,
      data: payload
    };

    return httpClient.postAsync(request, true);
  }
  /**
   * Xử lý khi click để sau
   * @param {} payload 
   * @returns 
   */
  dismissExpirationNotification(payload) {
    const me = this;
    let request = {
      url: `${this.getAPIUrl()}/dismiss-expiration`,
      data: payload
    };

    return httpClient.postAsync(request, true);
  }
}

export default new SubscriberAPI();
